import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import lang from '../../../lib/language';

import TradeViewBtnIcon from '../../../assets/img/trade_chart_btn.svg';
import { useIsMobile } from '../../../hooks';
import { UI_ROUTES } from '../../../util/routes';
import { ClickableDiv } from '../..';

import styles from './TradeViewChartButton.module.scss';

type Props = {
  symbol: string;
};

const TradeViewChartButton = ({ symbol }: Props) => {
  const { isMobile } = useIsMobile();
  const navigate = useNavigate();

  const onMobileClick = () => {
    if (isMobile) {
      navigate(`${UI_ROUTES.tradingView}/${symbol}`);
    }
  };
  return (
    <ClickableDiv
      className={classNames(styles.wrapper, { [styles.wrapperMob]: isMobile })}
      onClick={onMobileClick}
    >
      <img src={TradeViewBtnIcon} alt="Tradeview Chart" />
      {!isMobile && (
        <a href={`${UI_ROUTES.tradingView}/${symbol}`} target={'_self'} rel="noreferrer">
          {lang.tradingViewChartLabel()}
        </a>
      )}
    </ClickableDiv>
  );
};

export default TradeViewChartButton;
